import posthog from "posthog-js";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;
export const isPosthogConfigured = Boolean(posthogKey && posthogHost);

if (!posthogKey) {
  if (import.meta.env.DEV) {
    throw new Error(
      "VITE_POSTHOG_KEY variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_KEY is configured"
    );
  }
} else if (!posthogHost) {
  if (import.meta.env.DEV) {
    throw new Error(
      "VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_HOST is configured"
    );
  }
} else {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    logs: {
      serviceName: "rise-and-fall-storefront",
      environment: import.meta.env.MODE
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false
    },
    capture_pageview: false,
    opt_out_capturing_by_default: true,
    opt_out_persistence_by_default: true
  });

  let pageviewCaptured = false;

  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;

  const syncConsent = () => {
    if (!analyticsAllowed()) {
      if (posthog.is_capturing()) posthog.opt_out_capturing();
      return;
    }

    const customer = window.posthogCustomer;
    const customerId = customer?.id ? String(customer.id) : null;
    const previousCustomerId = posthog.get_property("$user_id");

    if (previousCustomerId && String(previousCustomerId) !== customerId) {
      posthog.reset();
    }

    if (!posthog.is_capturing()) {
      posthog.opt_in_capturing({ captureEventName: false });
    }

    if (customerId) {
      posthog.identify(customerId, {
        ...(customer.email && { email: customer.email }),
        ...(customer.name && { name: customer.name })
      });
    }

    if (!pageviewCaptured) {
      pageviewCaptured = true;
      posthog.capture("$pageview");
    }
  };

  document.addEventListener("visitorConsentCollected", syncConsent);

  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else {
    window.Shopify?.loadFeatures?.([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
      if (!error) syncConsent();
    });
  }
}

export default posthog;
